import React, { useEffect, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import { AIStore } from 'services/store/ai';
import GuideArticle from './GuideArticle';
import GuideSideBar from './GuideSideBar';

type PropTypes = {
  data: AIStore['infoGuide'];
  open: boolean;
  setOpen: (open: boolean) => void;
};

const InfoGuideContent = ({ data, open, setOpen }: PropTypes) => {
  const theme = useTheme();
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (open) return;
    setTimeout(() => {
      setValue(0);
    }, 500);
  }, [open]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplate: {
          xs: `'sidebar content'`,
        },
        gridTemplateColumns: {
          xs: 'minmax(35%, 300px) minmax(65%, 550px)',
        },
        maxHeight: theme.spacing(65),
        minHeight: theme.spacing(65),
        justifyContent: 'center',
      }}
    >
      <GuideSideBar
        data={data}
        gridArea="sidebar"
        index={0}
        value={value}
        handleChange={handleChange}
      />
      <GuideArticle
        data={data}
        gridArea="content"
        value={value}
        open={open}
        setOpen={setOpen}
      />
    </Box>
  );
};

export default InfoGuideContent;
